<template>
  <div class="movies-faq-area pb-100">
    <div class="container">
      <div
        class="section-title text-center mw-860 m-auto"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <h2 class="text-white">لديك أسئلة؟ نحن هنا للمساعدة</h2>
        <p class="text-white">
          جمعنا لك أكثر الأسئلة الشائعة التي يطرحها عملاؤنا لتسهيل بَدْء تجربتك معنا واكتشاف ميزات السيرفر.
        </p>
      </div>
      <div
        class="row justify-content-center g-5"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="200"
      >
        <div
          v-for="(faqList, index) in faqGroups"
          :key="index"
          class="col-lg-6 col-md-12"
        >
          <div class="movies-faq-content">
            <div class="accordion">
              <div
                class="accordion-item"
                v-for="(faq, idx) in faqList"
                :key="idx"
                :class="{ active: activeIndexes[index] === idx }"
              >
                <h2 class="accordion-header">
                  <button
                    class="accordion-button"
                    type="button"
                    :aria-expanded="
                      activeIndexes[index] === idx ? 'true' : 'false'
                    "
                    @click="toggleAccordion(index, idx)"
                  >
                    {{ faq.question }}
                  </button>
                </h2>
                <div
                  class="accordion-collapse collapse show"
                  v-show="activeIndexes[index] === idx"
                >
                  <div class="accordion-body">
                    <p>{{ faq.answer }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="movies-faq-bottom-title">
        <span>
          لم تجد إجابة لسؤالك؟
          <RouterLink to="/contact-us">تواصل معنا من هنا</RouterLink>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "FAQ",
  setup() {
    const activeIndexes = ref<number[]>(new Array(2).fill(-1));
    activeIndexes.value[0] = 0;
    activeIndexes.value[1] = 0;

    const faqGroups = ref([
      [
        {
          question: "ما هي الأجهزة التي يدعمها السيرفر؟",
          answer:
            "نحن ندعم جميع الأجهزة الذكية: الشاشات الذكية (Smart TV)، أجهزة الأندرويد والـ TV Box، أجهزة Apple TV، الهواتف المحمولة، والكمبيوتر، بالإضافة إلى أجهزة الماج والأجهزة الداعمة لملفات M3U.",
        },
        {
          question: "كيف يمكنني الحصول على الدعم الفني؟",
          answer:
            "نوفر لك دعماً فنياً متميزاً وسريعاً على مدار الساعة عبر الواتساب للإجابة على استفساراتك وحل أي مشكلة قد تواجهك أثناء إعداد أو تشغيل الخدمة.",
        },
        {
          question: "كم يستغرق تفعيل الاشتراك بعد الدفع؟",
          answer:
            "يتم تفعيل الاشتراك وإرسال بيانات التشغيل الخاصة بك فوراً بعد تأكيد عملية الدفع، وغالباً ما يستغرق الأمر دقائق معدودة لتصبح الخدمة جاهزة لديك.",
        },
        {
          question: "هل توفرون تجربة مجانية قبل الاشتراك؟",
          answer:
            "نعم بكل تأكيد، يمكنك طلب تجربة مجانية تماماً لفترة محدودة لتتأكد من جودة القنوات، ثبات البث، وتنوع مكتبة الأفلام والمسلسلات قبل اتخاذ قرار الاشتراك.",
        },
      ],
      [
        {
          question: "كيف أبدأ بتشغيل الخدمة على شاشتي؟",
          answer:
            "الأمر بسيط جداً ولا يتطلب خبرة تقنية؛ كل ما عليك فعله هو تحميل أحد التطبيقات المعتمدة لدينا على شاشتك، ثم إدخال بيانات الاشتراك التي سنرسلها لك.",
        },
        {
          question: "هل يمكنني تشغيل الاشتراك على أكثر من جهاز؟",
          answer:
            "الاشتراك القياسي يمنحك خط اتصال لجهاز واحد في نفس الوقت. إذا كنت ترغب في تشغيل الخدمة على عدة أجهزة معاً، يمكنك التواصل معنا لتوفير باقة مخصصة للمشاهدة المتعددة.",
        },
        {
          question: "هل يمكنني استخدام الخدمة أثناء السفر؟",
          answer:
            "نعم، يمكنك الاستمتاع بمشاهدة قنواتك المفضلة ومتابعة المباريات من أي مكان في العالم، بشرط توفر اتصال إنترنت مستقر وجيد.",
        },
        {
          question: "ما هي سرعة الإنترنت المطلوبة للبث؟",
          answer:
            "للاستمتاع ببث ثابت وبدون تقطيع بجودة عالية (FHD و 4K)، نوصي بتوفر سرعة إنترنت لا تقل عن 20 ميجابت في الثانية، ويفضل توصيل الجهاز عبر الكابل مباشرة.",
        },
      ],
    ]);

    const toggleAccordion = (groupIndex: number, itemIndex: number) => {
      activeIndexes.value[groupIndex] =
        activeIndexes.value[groupIndex] === itemIndex ? -1 : itemIndex;
    };

    return {
      activeIndexes,
      toggleAccordion,
      faqGroups,
    };
  },
});
</script>